module.exports = __webpack_public_path__ + "img/xcode.cb5bdc94.png";